export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-30.86c93394.jpg";